import { isPlain } from '@reduxjs/toolkit';
import styled from 'styled-components';

type DirectionType = 'top' | 'right' | 'bottom' | 'left';

interface ChevronProps {
  direction: DirectionType;
  isTight: boolean;
}

export const Chevron = styled.div<ChevronProps>`
  height: 16px;
  width: 16px;

  transition: all 0.25s ease-in-out;

  transform: ${(p) => p.direction === 'top' && 'rotate(180deg)'};
  transform: ${(p) => p.direction === 'right' && '-rotate(90deg)'};
  transform: ${(p) => p.direction === 'bottom' && 'rotate(0deg)'};
  transform: ${(p) => p.direction === 'left' && 'rotate(90deg)'};

  position: absolute;
  right: ${(p) => (p.isTight ? '0px' : '24px')};
`;

export const Container = styled.div`
  & + & {
    /* margin-top: -0.125rem; */
  }
`;

export const Title = styled.div<{
  isExpanded: boolean;
  isPlain: boolean;
  isTight: boolean;
}>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-top: ${(p) =>
    !p.isExpanded && !p.isPlain ? '1px solid gainsboro' : 'none'};

  margin-top: ${(p) => (p.isExpanded ? '12px' : '0px')};

  .ant-row.ant-form-item {
    width: 100%;
  }

  .ant-row.ant-form-item {
    height: 32px;
    margin-bottom: 0;
  }
  position: relative;
  padding-top: ${(p) => (p.isExpanded ? '0px' : '20px')};
  padding-top: ${(p) => p.isTight && !p.isExpanded && '0px'};
`;

export const Content = styled.div`
  color: rgba(0, 0, 0, 0.75);
  line-height: 1.5;

  .ant-form-item {
  }

  .ant-row.ant-form-item {
    height: 24px;
  }

  .ant-row.ant-form-item:last-child {
    margin-bottom: 8px;
  }
`;

export const ContentWrapper = styled.div<{
  maxHeight: number;
  isExpanded: boolean;
  isPlain: boolean;
  isTight: boolean;
}>`
  border-top: ${(p) =>
    p.isExpanded && !p.isPlain ? '1px solid gainsboro' : 'none'};
  max-height: ${(p) => `${p.maxHeight}px`};
  transition: max-height 0.25s ease-in-out;
  padding-top: ${(p) => (p.isExpanded ? '20px' : '0px')};
  overflow: hidden;

  padding-top: ${(p) => (p.isTight ? '0px' : '20px')};
`;
